/* eslint-disable */
/* tslint:disable */
import PropTypes from 'prop-types';
import React from 'react';
export const ContactOwnerWhite = ({size, ...props}) => (
  <svg viewBox="0 0 14 16" fill="currentColor" width={ size || "14" } height={ size || "16" } {...props}>
    <g fill="#FFF" fillRule="evenodd">
      <path d="M6 6V4.732C6.598 4.387 7 3.74 7 3c0-1.105-.895-2-2-2s-2 .895-2 2c0 .74.402 1.387 1 1.732v1.394C2.275 6.57 1 8.136 1 10v1h4v1H1c-.552 0-1-.448-1-1v-1c0-2.105 1.301-3.906 3.143-4.644C2.447 4.806 2 3.956 2 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 .89-.388 1.69-1.005 2.24L7 6H6z"
      />
      <path d="M12.667 7c.703 0 1.278.52 1.33 1.178l.003.095v3.459c0 .671-.544 1.22-1.234 1.27l-.1.003H9.768l-1.915 1.957c-.055.035-.12.054-.185.054-.164 0-.3-.113-.328-.261l-.006-.058v-1.692l-.1-.004c-.655-.046-1.178-.544-1.229-1.17L6 11.733v-3.46c0-.67.544-1.22 1.234-1.269l.1-.003h5.333zM12.4 8.024H7.623l-.068.001c-.287.021-.516.239-.55.513l-.004.07v2.778l.002.069c.02.262.22.476.463.525l.067.01.618.023-.001 1.412 1.242-1.433h2.986l.067-.001c.288-.021.517-.239.55-.513l.005-.07v-2.78l-.002-.065c-.02-.28-.245-.502-.526-.535l-.072-.004z"
        transform="matrix(-1 0 0 1 20 0)" />
    </g>
  </svg>
);
ContactOwnerWhite.displayName = 'ContactOwnerWhite';
ContactOwnerWhite.propTypes = {
  size: PropTypes.string
}
/* tslint:enable */
/* eslint-enable */
